import { NgModule } from '@angular/core';
import {MedicalDeviceAccountModule} from "./account/medicalDeviceAccount.module";
import {DeviceDefinitionModule} from "./definition/deviceDefinition.module";
@NgModule({
  imports: [
    DeviceDefinitionModule,
    MedicalDeviceAccountModule,
  ]
})
export class MedicalDeviceModule {
}

